import { useCart } from "@/hooks/use-cart";
import { useAuthStatus } from "@/hooks/use-auth-status";
import { useEffect } from "react";

import cartInitializerAtom from "@/atoms/cart-initializer";
import categoriesAtom from "@/atoms/categories";
import { FeedbackModal } from "@/components/feedback";
import { Button, Icon } from "@/components/ui";
import { cartSyncEnabled } from "@/consts";
import { CartIcon, ClockCounterClockwise, Plus } from "@/icons";
import { cartBackendService } from "@/lib/cart-backend-service";
import { useAtom, useAtomValue } from "jotai";

export const CartInitializer = () => {
  const { loadInitialCart, clearLocalStorage, loadFromLocalStorage } = useCart();
  const [cartInitializer, setCartInitializer] = useAtom(cartInitializerAtom);
  const categories = useAtomValue(categoriesAtom);
  const isAuthenticated = useAuthStatus();

  useEffect(() => {
    loadInitialCart();
  }, [loadInitialCart, isAuthenticated]);

  const handleKeepCart = async () => {
    await cartBackendService.clearCart();
    await loadInitialCart(true);
    setCartInitializer(false);
  };

  const handleGroupCart = async () => {
    const cart = loadFromLocalStorage();
    if (cart.items.length > 0) {
      await cartBackendService.saveCart(cart, categories);
      clearLocalStorage();
    }
    await loadInitialCart(true);
    setCartInitializer(false);
  };

  const handleDiscardCart = () => {
    clearLocalStorage();
    loadInitialCart(true);
    setCartInitializer(false);
  };

  if (!cartSyncEnabled) return null;

  return (
    <FeedbackModal
      open={cartInitializer}
      onOpenChange={setCartInitializer}
      variant="info"
      dismissible={false}
      title="Encontramos uma sacola salva"
      description="Você tem itens salvos de antes e itens na sacola atual. Qual sacola quer usar?"
      actions={
        <>
          <Button
            variant="outline"
            tone="neutral"
            fullWidth
            onClick={handleDiscardCart}
          >
            <Icon as={ClockCounterClockwise} size="md" />
            Usar a sacola salva
          </Button>

          <Button fullWidth onClick={handleKeepCart}>
            <Icon as={CartIcon} size="md" />
            Manter a sacola atual
          </Button>

          <Button tone="secondary" fullWidth onClick={handleGroupCart}>
            <Icon as={Plus} size="md" />
            Juntar tudo
          </Button>
        </>
      }
    />
  );
};
